import Vue from 'vue'
import VueRouter from 'vue-router'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import { getCookie, setCookie } from "../utils/cookies";

Vue.use(Buefy);
Vue.use(VueRouter);

const routes = [{
        path: '/',
        name: 'Home',
        component: () =>
            import ('../views/Home.vue'),
        meta: {
            title: 'Memomental | Flashcard app',
            metaTags: [{
                    name: 'description',
                    content: 'Memomental est une application qui te permet d\'apprendre tout ce que tu as toujours voulu savoir !'
                },
                {
                    name: 'keywords',
                    content: 'Memomental, Memoire, Apprentissage, Flashcards app'
                },
                {
                    name: 'author',
                    content: 'Florine PRATLONG & Axel DUVAL'
                }
            ],
            meta: [
                { property: 'og:title', content: "Memomental - Quand travailler sa mémoire devient amusant" },
                { property: 'og:site_name', content: 'Memomental' },
                { property: 'og:type', content: 'website' },
            ]
        },
    },
    {
        path: '/credentials/',
        name: 'Credentials',
        component: () =>
            import ('../views/Credentials.vue'),
        meta: {
            title: 'Memomental | Authentification',
            meta: [
                { property: 'og:title', content: "Memomental - insciption - connexion - commencer à jouer" },
                { property: 'og:site_name', content: 'Memomental' },
                { property: 'og:type', content: 'website' },
            ]
        },
    },
    {
        path: '/demo/',
        name: 'Demo',
        component: () =>
            import ('../views/Demo.vue'),
        meta: {
            title: 'Memomental | Demo',
            meta: [
                { property: 'og:title', content: "Memomental - Demo" },
                { property: 'og:site_name', content: 'Memomental' },
                { property: 'og:type', content: 'website' },
            ]
        },
    },
    {
        path: '/reviewing/',
        name: 'Reviewing',
        component: () =>
            import ('../views/Reviewing.vue'),
        meta: {
            title: 'Memomental | Apprentissage',
            meta: [
                { property: 'og:title', content: "Memomental - Réviser des flashcards en s'amusant" },
                { property: 'og:site_name', content: 'Memomental' },
                { property: 'og:type', content: 'website' },
            ]
        },
    },
    {
        path: '/store/',
        name: 'Store',
        component: () =>
            import ('../views/Store.vue'),
        meta: {
            title: 'Memomental | Boutique',
            meta: [
                { property: 'og:title', content: "Memomental - Trouver de nouveaux paquets de cartes" },
                { property: 'og:site_name', content: 'Memomental' },
                { property: 'og:type', content: 'website' },
            ]
        },
    },
    {
        path: '/packages/',
        name: 'Packages',
        component: () =>
            import ('../views/Packages.vue'),
        meta: {
            title: 'Memomental | Mes paquets',
            meta: [
                { property: 'og:title', content: "Memomental - Voir mes paquets" },
                { property: 'og:site_name', content: 'Memomental' },
                { property: 'og:type', content: 'website' },
            ]
        },
    },
    {
        path: '/packages/:idPackage/',
        name: 'Cards',
        component: () =>
            import ('../views/Cards.vue'),
        meta: {
            title: 'Memomental | Mes cartes',
            meta: [
                { property: 'og:title', content: "Memomental - Voir mes flashcards" },
                { property: 'og:site_name', content: 'Memomental' },
                { property: 'og:type', content: 'website' },
            ]
        },
    },
    {
        path: '/share/:header/:payload/:signature/',
        name: 'SharedPackage',
        component: () =>
            import ('../views/Share.vue'),
        meta: {
            title: 'Memomental | Partage de paquet',
            meta: [
                { property: 'og:title', content: "Memomental - Partager des paquets avec mes amis" },
                { property: 'og:site_name', content: 'Memomental' },
                { property: 'og:type', content: 'website' },
            ]
        },
    },
    {
        path: '/share/:idPackage/',
        name: 'Share',
        component: () =>
            import ('../views/Share.vue'),
        meta: {
            title: 'Memomental | Partage de paquet',
            meta: [
                { property: 'og:title', content: "Memomental - Partager des paquets avec mes amis" },
                { property: 'og:site_name', content: 'Memomental' },
                { property: 'og:type', content: 'website' },
            ]
        },
    },
    {
        path: '/friends/',
        name: 'Friends',
        component: () =>
            import ('../views/Friends.vue'),
        meta: {
            title: 'Memomental | Amis',
            meta: [
                { property: 'og:title', content: "Memomental - Challenger mes amis dans le jeu" },
                { property: 'og:site_name', content: 'Memomental' },
                { property: 'og:type', content: 'website' },
            ]
        },
    },
    {
        path: '/contests/',
        name: 'Contests',
        component: () =>
            import ('../views/Contests.vue'),
        meta: {
            title: 'Memomental | Challenges',
            meta: [
                { property: 'og:title', content: "Memomental - Challenger mes amis dans le jeu" },
                { property: 'og:site_name', content: 'Memomental' },
                { property: 'og:type', content: 'website' },
            ]
        },
    },
    {
        path: '/dashboard/',
        name: 'Dashboard',
        component: () =>
            import ('../views/Dashboard.vue'),
        meta: {
            title: 'Memomental | Menu',
            meta: [
                { property: 'og:title', content: "Memomental - Vue générale de l'application" },
                { property: 'og:site_name', content: 'Memomental' },
                { property: 'og:type', content: 'website' },
            ]
        },
    },
    {
        path: '/statistics/',
        name: 'Statistics',
        component: () =>
            import ('../views/Statistics.vue'),
        meta: {
            title: 'Memomental | Performances',
            meta: [
                { property: 'og:title', content: "Memomental - Voir mes performances de révision" },
                { property: 'og:site_name', content: 'Memomental' },
                { property: 'og:type', content: 'website' },
            ]
        },
    },
    {
        path: '/position/',
        name: 'Position',
        component: () =>
            import ('../views/Position'),
        meta: {
            title: 'Memomental | Classement',
            meta: [
                { property: 'og:title', content: "Memomental - Voir mon classement et celui de mes amis" },
                { property: 'og:site_name', content: 'Memomental' },
                { property: 'og:type', content: 'website' },
            ]
        },
    },
    {
        path: '/ranking/:idContest/',
        name: 'contestRanking',
        component: () =>
            import ('../views/ContestRanking'),
        meta: {
            title: 'Memomental | Classement challenge',
            meta: [
                { property: 'og:title', content: "Memomental - Voir mon classement et celui de mes amis" },
                { property: 'og:site_name', content: 'Memomental' },
                { property: 'og:type', content: 'website' },
            ]
        },
    },
    {
        path: '/playing/:idContest/',
        name: 'playContest',
        component: () =>
            import ('../views/PlayContest'),
        meta: {
            title: 'Memomental | Relever le challenge',
            meta: [
                { property: 'og:title', content: "Memomental - Challenge tes amis sur ce contest" },
                { property: 'og:site_name', content: 'Memomental' },
                { property: 'og:type', content: 'website' },
            ]
        },
    },
    {
        path: '/reminderTable/',
        name: 'ReminderTable',
        component: () =>
            import ('../views/ReminderTable'),
        meta: {
            title: 'Memomental | Table de rappel',
            meta: [
                { property: 'og:title', content: "Memomental - Qu'est ce que la table de rappel ?" },
                { property: 'og:site_name', content: 'Memomental' },
                { property: 'og:type', content: 'website' },
            ]
        },
    },
    {
        path: '/help/',
        name: 'Helps',
        component: () =>
            import ('../views/Helps'),
        meta: {
            title: 'Memomental | Aide',
        },
    },
    {
        path: '/mission/',
        name: 'Missions',
        component: () =>
            import ('../views/Mission'),
        meta: {
            title: 'Memomental | Mission',
        },
    },
    {
        path: '/account/',
        name: 'Account',
        component: () =>
            import ('../views/Account'),
        meta: {
            title: 'Memomental | Mon compte',
        },
    },
    {
        path: '/privacy/',
        name: 'CGU',
        component: () =>
            import ('../views/CGU'),
        meta: {
            title: 'Memomental | CGU',
        },
    },
    {
        path: '/validation/:userId/:code',
        name: 'Validation',
        component: () =>
            import ('../views/Validation'),
        meta: {
            title: 'Memomental | Validation Compte',
        },
    },
    {
        path: '/*',
        name: 'All',
        redirect: "/"
    },
];


const router = new VueRouter({
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    const publicURLs = ['Home', 'Credentials', 'Demo', 'Validation', 'CGU']
    document.title = to.meta.title;
    const token = getCookie('token');
    if (token == null && !publicURLs.includes(to.name)) {
        if (to.name === 'Share' || to.name === 'SharedPackage') {
            setCookie('sharePackageLink', window.location.href, 10)
            return next({ path: '/credentials/' });
        } else {
            return next({ path: '/' });
        }
    } else {
        return next();
    }
});

router.onError(error => {
    console.log(error)
    if (getCookie('chunk-failed')) {
        console.log('Already retry to fetch new version')
        return;
    } else {
        console.log('Retry to fetch new version')
        window.location.reload()
        setCookie('chunk-failed', true, 0.01)
    }
})

export default router;
